import security from "../Core/security.modules";
import SECTIONS from "../modules";

const MODULES = {
  security,
  SECTIONS,
};

export default MODULES;
